export default "__VITE_ASSET__DpZrkUqX__"